import React from 'react';
import { useGetAllHouseholdsForShareSuspense, useGetAllOccupantAgeRangesForShareSuspense, useGetAllTenancyTypesForShareSuspense, } from '../../../../../services/api/generated/client';
import { unwrapModel } from '../../../../../services/api/unwrapModel';
import { useInspectionDetailShareContext } from '../../../../pages/upgrade/InspectionDetail/ShareInspection/InspectionDetailShareProvider';
import AddEditContactForm from '../AddEditContactForm';
const ContactFormShareWrapper = ({ variant }) => {
    const { token } = useInspectionDetailShareContext();
    const { data: ageRangesResponse } = useGetAllOccupantAgeRangesForShareSuspense(token, {
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const { data: tenancyTypesResponse } = useGetAllTenancyTypesForShareSuspense(token, { query: { staleTime: Infinity, refetchOnMount: false } });
    const { data: householdsResponse } = useGetAllHouseholdsForShareSuspense(token, {
        query: { staleTime: Infinity, refetchOnMount: false },
    });
    const ageRanges = unwrapModel(ageRangesResponse);
    const households = unwrapModel(householdsResponse);
    const tenancyTypes = unwrapModel(tenancyTypesResponse);
    if (!ageRanges || !households || !tenancyTypes)
        return null;
    return (React.createElement(AddEditContactForm, { canEdit: false, ageRanges: ageRanges, households: households, tenancyTypes: tenancyTypes, formVariant: variant }));
};
export default ContactFormShareWrapper;
